// material-ui
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

// project import
import NavCollapse from './NavCollapse';
import NavItem from './NavItem';
import NavGroup from './NavGroup';
import { Fragment, useEffect, useMemo, useState } from 'react';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
	const apiMenuItems = useSelector((state) => state.menu.menuItems);
	const drawerOpen = useSelector((state) => state.menu.drawerOpen);
	const openItem = useSelector((state) => state.menu.openItem);
	const [expandedKey, setExpandedKey] = useState(null);

	const normalizeNavKey = (value = '') =>
		String(value)
			.toLowerCase()
			.trim()
			.replace(/\s+/g, '-');

	const sectionGroups = useMemo(
		() => ({
			// 'lyn-process-create': { title: 'Create', selectionVariant: 'dark' },
			'lyn-process-worklist': { title: 'Worklist', selectionVariant: 'dark' },
			'lyn-process-my-cases': { title: 'My Cases', selectionVariant: 'dark' },
			'lyn-process-governance': { title: 'Resources', selectionVariant: 'dark' },
		}),
		[]
	);

	useEffect(() => {
		if (!Array.isArray(apiMenuItems) || apiMenuItems.length === 0) return;

		const openItemValue = openItem?.[0]?.toLowerCase?.();
		const normalizedOpenItem = openItemValue === 'in-progress' ? openItemValue : openItemValue?.replace('/', '')?.replace('-', ' ');

		const matchedParent = apiMenuItems.find((menuItem) =>
			(menuItem?.children ?? []).some((child) => child?.displayName?.toLowerCase?.() === normalizedOpenItem)
		);

		if (matchedParent?.displayName) {
			setExpandedKey(matchedParent.displayName.toLowerCase());
			return;
		}

		if (!openItemValue) {
			const hasWorklistCollapse = apiMenuItems.some(
				(menuItem) => menuItem?.displayName?.toLowerCase?.() === 'worklist' && (menuItem?.children ?? []).length > 0
			);

			if (hasWorklistCollapse) {
				setExpandedKey((prev) => prev ?? 'worklist');
			}
		}
	}, [apiMenuItems, openItem]);

	//=============== temporary comment do not remove this =============

	// if (Object?.keys(menuNotification)?.length === 0 && role?.[0]?.name !== "Lyn-Company-Administrator") {
	//   return (
	//     <Typography variant="span" align="center">
	//       Loading...
	//     </Typography>
	//   );
	// }

	const sortedMenuItems = [...(apiMenuItems ?? [])].sort((a, b) => a.serial - b.serial);

	const shouldKeepCollapsedItemsGrouped = (previousItem, currentItem) => {
		if (!previousItem || !currentItem) return false;

		const previousKeys = [
			normalizeNavKey(previousItem?.displayName),
			normalizeNavKey(previousItem?.name),
			normalizeNavKey(previousItem?.url),
		].filter(Boolean);
		const currentKeys = [
			normalizeNavKey(currentItem?.displayName),
			normalizeNavKey(currentItem?.name),
			normalizeNavKey(currentItem?.url),
		].filter(Boolean);

		const previousHas = (keyword) => previousKeys.some((key) => key.includes(keyword));
		const currentHas = (keyword) => currentKeys.some((key) => key.includes(keyword));

		const isInsightsCreatePair = previousHas('insight') && currentHas('create');
		const isResourcesCascadePair = (previousHas('resource') || previousHas('governance')) && currentHas('cascade');

		return isInsightsCreatePair || isResourcesCascadePair;
	};

	const navGroups = sortedMenuItems.map((item, index) => {
			const listCode = item?.name ?? '';
			const sectionConfig = sectionGroups[listCode] ?? null;
			const previousItem = sortedMenuItems[index - 1];
			const collapsedMarginTop = index === 0 ? 0 : shouldKeepCollapsedItemsGrouped(previousItem, item) ? 0 : 30;
			const showCollapsedDivider = !drawerOpen && index !== 0 && !shouldKeepCollapsedItemsGrouped(previousItem, item);

			const menuType = item.children && item.children.length > 0 ? (sectionConfig ? 'group' : 'collapse') : 'item';
			switch (menuType) {
				case 'group':
					return (
						<Box
							key={item.id}
							sx={{
								mt: drawerOpen ? 0 : `${collapsedMarginTop}px`,
								pt: showCollapsedDivider ? '30px' : 0,
								borderTop: showCollapsedDivider ? '1px solid #E5E7EB' : 'none',
							}}
						>
							<NavGroup
								item={item}
								index={index}
								level={1}
								accessor="displayName"
								expandedKey={expandedKey}
								setExpandedKey={setExpandedKey}
								sectionConfig={sectionConfig}
							/>
						</Box>
					);
				case 'collapse':
					return (
						<Box
							key={item.id}
							sx={{
								mt: drawerOpen ? 0 : `${collapsedMarginTop}px`,
								pt: showCollapsedDivider ? '30px' : 0,
								borderTop: showCollapsedDivider ? '1px solid #E5E7EB' : 'none',
							}}
						>
							<NavCollapse item={item} expandedKey={expandedKey} setExpandedKey={setExpandedKey} accessor="displayName" />
						</Box>
					);
				case 'item':
					return (
						<Box
							key={item.id}
							sx={{
								mt: drawerOpen ? 0 : `${collapsedMarginTop}px`,
								pt: showCollapsedDivider ? '30px' : 0,
								borderTop: showCollapsedDivider ? '1px solid #E5E7EB' : 'none',
							}}
						>
							<NavItem item={item} level={1} accessor="displayName" selectionVariant="brand" showIcon />
						</Box>
					);
				default:
					return (
						<Typography key={item.id} variant="h6" color="error" align="center">
							Fix - Navigation Group
						</Typography>
					);
			}
		});

	return (
		<Box component="nav" sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: drawerOpen ? '4px' : 0, fontSize: '0.875rem' }}>
			{navGroups}
		</Box>
	);
};

export default Navigation;
